<template>
  <div class="line-button max-w-276px">
    <a
      href="https://lin.ee/OlwsdqE"
      target="_blank"
      rel="noopener noreferrer"
      class="h-10 px-4 py-2 flex items-center gap-2 no-underline text-lg leading-6 rounded hover:bg-#f2fbf6 active:bg-#caeed9 text-black-60 border border-solid border-green-60 transition-colors whitespace-nowrap"
    >
      <svg-icon name="line" class="w-6 h-6 flex-shrink-0" />
      <span class="line-clamp-1 whitespace-normal">{{ $t('header_subscribe_line_group_btn') }}</span>
    </a>
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped></style>
